export default {
  "components": {
    "Account": {
      "UnReceivedCodeLink": {
        "5xz3hmxq1380": "未收驗證碼?",
        "5xz3hmxq4ws0": "關閉",
        "5xz3hmxq5800": "可能被識別為垃圾郵件,請至垃圾郵件中查看",
        "5xz3hmxq5fc0": "請檢查您輸入的郵箱是否正確,或者嘗試使用其他郵箱註冊",
        "5xz3hmxq5lo0": "請檢查當前網絡問題是否正常",
        "5xz3hmxq5s40": "未收到驗證碼?"
      }
    },
    "Empty": {
      "5weyj6xvl9o0": "暫無數據"
    },
    "ProComponent": {
      "ProConfirmPopup": {
        "5weyne0t7t40": "提示",
        "5weyne0tctw0": "確定",
        "5weyne0td2o0": "取消"
      }
    },
    "ScanCodeView": {
      "ScanCodeView": {
        "5weysudo0zk0": "此快遞單號存在非法字符,請重新掃描"
      },
      "ScanCameraApp": {
        "5weas1do0zk0": "正在獲取相機信息"
      }
    },
    "SearchBackBar": {
      "5weyueldnb00": "篩選"
    },
    "SelectView": {
      "5weyy43t5v00": "請輸入搜索關鍵詞",
      "5weyy43tasw0": "暫無數據"
    },
    "ShopTag": {
      "60aatigyeig0": "跨境"
    },
    "Warehouse": {
      "ScanModeSelect": {
        "5wez10tdkk80": "請選擇掃描方式",
        "5wez10tdpow0": "激光掃描",
        "5wez10tdpxg0": "相機掃描"
      },
      "StockModeSelect": {
        "5wez1zd63kw0": "請選擇入庫方式",
        "5wez1zd68ag0": "請選擇出庫方式"
      },
      "WarehouseSelect": {
        "5wez1mdf9v80": "請選擇倉庫",
        "5wez1mdfep80": "沒有倉庫權限,請聯繫主賬號添加"
      }
    }
  },
  "constants": {
    "package": {
      "5wskfpirawg0": "待提交",
      "5wskfpirer00": "失敗",
      "5wskfpirey40": "成功",
      "61y193pca400": "未使用庫存",
      "61y193pcccg0": "使用庫存",
      "61y193pccj40": "使用庫存發貨",
      "61y193pccnc0": "使用第三方庫存",
      "61y193pccr00": "使用第三方庫存發貨",
      "61y193pccv40": "預占庫存已取消",
      "62xov7r45u40": "使用供應商庫存",
      "62xov7r488c0": "使用供應商庫存發貨",
      "62xov7r48g00": "全部",
      "62xov7r48k40": "未付款",
      "62xov7r48ns0": "待處理",
      "62xov7r48rs0": "待打單",
      "62xov7r48vs0": "待攬收",
      "62xov7r48zw0": "已發貨",
      "62xov7r493g0": "售後中",
      "62xov7r49vg0": "已關閉",
      "62xov7r4aa80": "已擱置",
      "62xov7r4af40": "已完成",
      "62xov7r4akw0": "追加商品",
      "62xov7r4aps0": "贈品",
      "wait_seller_send": "待發貨",
      "refunding": "退款中",
      "in_cancel": "取消中",
      "returned": "已退還",
      "lost": "已丟失",
      "failed": "妥投失敗",
      "wait_confirmed": "待審核"
    },
    "platform": {
      "5zwog8ot6ow0": "手工订单",
      "5zwog8ot8zs0": "零售订单",
      "602uc1886b40": "Lazada全託管"
    },
    "shipment": {
      "5wsjxwq908g0": "掃描1次",
      "5wsjxwq96nc0": "掃描搜尋包裹並提交發貨",
      "5wsjxwq970k0": "掃描2次",
      "5wsjxwq97880": "掃描後,先搜尋包裹,再次掃描才自动发货",
      "5wsjxwq97ek0": "手動",
      "5wsjxwq97lo0": "自動",
      "5wsjxwq97s80": "忽略",
      "5wsjxwq97yo0": "強制",
      "5yjh2ncp5go0": "開啟",
      "5yjh2ncp6p80": "關閉"
    },
    "warehouse": {
      "62xoyv9pqz40": "單品",
      "62xoyv9prkw0": "組合品",
      "62xoyv9prpc0": "多規格",
      "62xoyv9prsg0": "自營倉庫",
      "62xoyv9pruw0": "第三方倉庫",
      "62xoyv9prxg0": "供應商",
      "62xoyva812na-0": "良品倉位",
      "62xoyva812na-1": "次品倉位",
      "62xoyva812na-2": "良",
      "62xoyva812na-3": "次"
    },
    "wave": {
      "noteCreate": "含備註",
      "manualCreate": "組合品",
      "sameGoodsSku": "同類包裹",
      "singleSkuMerge": "單品合併",
      "singleSkuSingleNum": "單品單數",
      "singleSkuMultiNum": "單品多數",
      "multiSku": "多品混合"
    }
  },
  "page_subject": {
    "order": {
      "components": {
        "SelectOrderPackagePopup": {
          "62xp0pvghso0": "請選擇包裹",
          "62xp0pvgi6k0": "確定",
          "62xp1g1eos00": "包裹號:",
          "62xp1g1ep5s0": "運單號:",
          "6302m89rsa00": "掃描訂單:"
        }
      },
      "orderDetail": {
        "components": {
          "EditAppNotePopup": {
            "62xpaforad40": "取消",
            "62xpaforarg0": "揀貨備註",
            "62xpaforatw0": "保存",
            "62xpaforavw0": "請輸入揀貨備註"
          },
          "OrderHeaderInfo": {
            "62xpa6a0ixw0": "訂單狀態",
            "62xpa6a0jdo0": "訂單號碼",
            "62xpa6a0jgo0": "包裹號碼",
            "62xpa6a0jk00": "物流",
            "62xpa6a0jls0": "運單號碼"
          },
          "OrderItemsInfo": {
            "62xp9e9s1jw0": "有{0}個產品未配對倉庫商品",
            "62xp9e9s26c0": "未配對商品SKU",
            "62xp9e9s2ao0": "平台SKU",
            "62xp9e9s2dg0": "商品SKU",
            "62xp9e9s2fs0": "包裹產品",
            "62xp9e9s2j00": "倉庫商品",
            "62xp9e9s2l40": "組合品",
            "630xvmqtrsg0": "分銷"
          },
          "OrderNoteInfo": {
            "62xp8zszea00": "買家留言",
            "62xp8zszes00": "商家備註",
            "62xp8zszevw0": "揀貨備註"
          },
          "OrderTimeAndConsigneeInfo": {
            "62xp8jq79go0": "下單時間",
            "62xp8jq79wk0": "付款時間",
            "62xp8jq7a080": "收件人",
            "62xp8jq7a2w0": "聯繫電話",
            "62xp8jq7a580": "收件地址",
            "6303ysgdkgw0": "提醒:{0}官方要求,收件人信息脫敏展示"
          }
        },
        "hooks": {
          "useOrderDetail": {
            "62xp6xk9r7w0": "保存中",
            "62xp6xk9s0c0": "保存成功",
            "62xp6xk9s7k0": "加載中"
          }
        },
        "index": {
          "62xp5jhypsk0": "訂單詳情",
          "62xp5jhyqh00": "同訂單其他包裹"
        }
      }
    },
    "systemMessage": {
      "messageDetail": {
        "index": {
          "62xpa5es215c": "系統消息",
          "62xpa5es215c-1": "截止{0}，以下倉庫商品SKU的可用庫存、在途庫存及計劃庫存總和低於安全庫存閾值，請及時補貨！",
          "62xpa5es215c-2": "倉庫名稱：",
          "62xpa5es215c-3": "低於安全庫存的商品種類："
        }
      },
      "messageList": {
        "index": {
          "62xpe1gs85ax": "系統消息",
          "62xpe1gs85ax-1": "暫無消息"
        }
      }
    },
    "warehouse": {
      "components": {
        "ScanOrderPackageStatusErrorPopup": {
          "62xpfn9iq1o0": "訂單狀態",
          "62xpfn9iqi80": "訂單號碼",
          "62xpfn9iqmc0": "包裹號碼",
          "62xpfn9iqow0": "物流",
          "62xpfn9iqr40": "運單號碼",
          "62xpfn9iqxc0": "訂單詳情",
          "62xpfn9iqzw0": "關閉"
        }
      },
      "constant": {
        "5poktrsnz680": "已占用(僅當前SKU)",
        "5poktrsnza40": "已占用(含當前SKU)",
        "5poktrsnze40": "已占用(不含當前SKU)",
        "5rb0n6tm1pk0": "可回收(僅當前SKU)",
        "5rb0n6tm3740": "可回收(含當前SKU)",
        "5rb0n6tm3bs0": "可回收(不含當前SKU)",
        "5poktrsnz240": "空閒"
      },
      "scanSearchOrder": {
        "index": {
          "62xpe5xweg40": "掃描查單",
          "62xpe5xwez80": "掃描或輸入包裹號/運單號/訂單號",
          "62xpe5xwf2s0": "請掃描包裹信息",
          "62xpe5xwf4o0": "加載中",
          "62xpe5xwf6c0": "未搜到該包裹"
        }
      }
    }
  },
  "pages": {
    "account": {
      "components": {
        "TwoFactorAuthenticationPopup": {
          "60ae807iv8k0": "異地登錄安全驗證",
          "60ae807ivnc0": "您正在",
          "60ae807ivq00": "異地登錄",
          "60ae807ivq01": "，",
          "60ae807ivrw0": "為保障賬號安全，登錄前請完成驗證。",
          "60ae807ivtg0": "獲取驗證碼",
          "60ae807ivvs0": "立即驗證",
          "60ae807ivys0": "請輸入郵箱驗證碼",
          "60ae807iw0s0": "請輸入簡訊驗證碼",
          "60ae807iw3o0": "請輸入驗證碼!",
          "60ae807iw5w0": "正在獲取驗證碼",
          "60ae807iw7s0": "已成功发送验证码",
          "60ae8fkmn680": "重新發送{0}",
          "60gic918gtg0": "验证成功",
          "60gicqrsmqk0": "登錄地"
        }
      },
      "currencyAndTimeZone": {
        "currencyAndTimeZone": {
          "index": {
            "60wmecfnlrg0": "幣種",
            "60wmecfnmfo0": "請選擇幣種",
            "60wmecfnmfo2": "系統內商品成本、利潤等金額,將用{0}展示;選擇後,不支持修改",
            "60wmecfnmjs0": "時區",
            "60wmecfnmms0": "請選擇時區",
            "60wmecfnmpo0": "保存",
            "60wmecfnms40": "提示",
            "60wmecfnmuo0": "選擇了幣種後,不支持再修改,確定選擇當前幣種?",
            "60wmecfnmws0": "保存成功",
            "60wmecfnlrg4": "選擇幣種與時區"
          }
        }
      },
      "forget-password": {
        "index": {
          "5weq2lrg6780": "手機號碼",
          "5weq2lrg7a40": "請輸入手機號",
          "5weq2lrg7fg0": "新密碼",
          "5weq2lrg7io0": "請輸入密碼",
          "5weq2lrg7lk0": "密碼長度需大於等於8位字符，且必須包含大小寫字母，特殊符號和數字",
          "5weq2lrg7os0": "確認密碼",
          "5weq2lrg7s00": "驗證碼",
          "5weq2lrg7uw0": "請輸入驗證碼",
          "5weq2lrg8580": "重置密碼",
          "5weq2lrg88k0": "手機號格式不正確",
          "5weq2lrg8bg0": "兩次輸入的密碼不一致",
          "5weq2lrg8eg0": "正在獲取驗證碼",
          "5weq2lrg8h40": "驗證碼已發送",
          "5weq2lrg8jw0": "修改成功"
        },
        "page": {
          "forgetPassword": "忘記密碼"
        }
      },
      "login": {
        "5rnx1lpiie80": "賬號",
        "5rnx1lpiwp40": "密碼",
        "5rnx1lpiwz40": "登錄",
        "5rnx1lpix540": "忘記密碼",
        "5rnx1lpix9s0": "註冊賬號",
        "5rnx1lpixes0": "請輸入郵箱/手機號碼/子帳號",
        "5rnx1lpixko0": "郵箱/手機號碼/子帳號必填",
        "5rnx1lpixps0": "賬號不存在,請重新輸入",
        "5rnx1lpixus0": "密碼必填",
        "5rnx1lpiy5g0": "密碼錯誤,請重新輸入",
        "5rnx1lpiyk00": "賬號不存在",
        "5rnx1lpiyqc0": "密碼不正確",
        "5rnx1lpiyv00": "獲取驗證碼",
        "5rnx1lpiyyc0": "秒重新獲取",
        "5rnx1lpiz2g0": "重新獲取",
        "5rnx1lpixhg0": "返回",
        "agreeCheckTipsBefore": "我已閱讀並同意",
        "userAgreement": "用戶服務協議、",
        "privacyAgreement": "隱私協議",
        "checkAgreeTitle": "提示",
        "checkAgreeUserAgreement": "請仔細閱讀並同意用戶服務協議、隱私協議"
      },
      "register": {
        "register": {
          "placeholder": {
            "email": "請輸入電子郵箱",
            "password": "請輸入密碼",
            "password2": "再次確認密碼",
            "mobile": "請輸入手機號",
            "emailValidateCode": "請輸入郵箱驗證碼",
            "mobileValidateCode": "請輸入手機驗證碼"
          },
          "getValidateCodeBtn": "獲取驗證碼",
          "agreeCheckTipsBefore": "我已閱讀並同意",
          "agreeCheckTipsAfter": {
            "userAgreement": "用戶服務協議、",
            "privacyAgreement": "隱私協議"
          },
          "confirm": "免費註冊",
          "success": {
            "message": "註冊成功",
            "tips": "請按以下步驟登錄並使用EasyBoss",
            "copyLink": "複製鏈接",
            "jumpToPc": "進入電腦端軟件界面"
          },
          "validatorError": {
            "password": "密碼長度需大於等於8位字符，且必須包含大小寫字母，特殊符號和數字",
            "email": "郵箱格式不正確",
            "mobile": "手機號格式不正確",
            "checkedAgree": "請選擇協議",
            "passwordNotSame": "兩次輸入的密碼不一致"
          },
          "gettingValidateCode": "正在獲取驗證碼",
          "validateCodeSendSuccess": "驗證碼已發送",
          "mobileCountryCode": "請選擇區號",
          "5weqrdhch7o0": "註冊",
          "5weqrdhci4w0": "密碼長度需大於等於8位字符，且必須包含大小寫字母，特殊符號和數字",
          "5weqrdhci9k0": "確認密碼",
          "5weqrdhcicw0": "福州劍奇雲網絡科技有限公司",
          "5weqrdhcijs0": "版權所有",
          "5weqrdhcimw0": "閩ICP備2020020145號-5",
          "index": {
            "61f8z24qhjg0": "圖形驗證碼不正確"
          }
        },
        "copy": {
          "success": "複製成功"
        },
        "page": {
          "register": "註冊"
        },
        "greatboss": {
          "register": {
            "success": {
              "tips": "請按以下步驟登錄並使用GreatBoss"
            }
          }
        }
      }
    },
    "distribution": {
      "bind": {
        "hooks": {
          "useDistributionBind": {
            "5yg2wlqzuo00": "操作成功",
            "5yg2wlqzus40": "提示",
            "5yg2wlqzuus0": "我已知曉",
            "5yg2wlqzuxc0": "合作邀請鏈接已過期,請聯繫供應商索要新的邀請合作鏈接",
            "5yg2wlqzuxa0": "您已和供應商{0}建立合作!",
            "5yg2wlqzuxt0": "您已向供應商{0}發起合作申請! 請等待供應商審核",
            "5yg2wlqzuxi0": "供應商{0}已與您終止合作,請您聯繫供應商",
            "5yg2wlqzuxp0": "供應商{0}狀態異常,暫時無法合作",
            "5yg2wlqzuxh0": "供應商已關閉分銷流程,無法合作",
            "5yg2wlqzuyr0": "請使用主賬號登錄建立合作關係",
            "5yg2wlqzuo01": "請閱讀並同意分銷合作須知"
          }
        },
        "protocol": {
          "index": {
            "60j4x24i71g8": "分銷邀請",
            "60j4x24i71g0-1": "《EasyBoss ERP·分銷合作須知》",
            "60j4x24i71g2-1": "尊敬的用戶，歡迎您使用EasyBoss ERP分銷合作功能！在使用EasyBoss ERP分銷合作功能之前，您應當認真閱讀並遵守《EasyBoss ERP-分銷合作須知》。",
            "60j4x24i71g3-1": "1.供應商、分銷商可通過EasyBoss ERP分銷工具開展分銷合作業務，雙方均在自願、自主基礎上展開合作，對於合作中產生的鋪貨、訂單、售後、資金等相關問題，請供分銷雙方友好解決，EasyBoss ERP不提供任何擔保且對雙方的合作不負有任何義務。",
            "60j4x24i71g4-1": "2.在EasyBoss ERP上傳、編輯的商品信息（包括但不限於供貨價、產品的描述和說明、相關圖片、視頻等）由供應商、分銷商自行提供，供應商、分銷商應保證商品信息及自身行爲合法性且不侵犯任何第三方權益，如因供應商、分銷商進行上述行爲所產生的一切後果，由供應商、分銷商自行承擔，同時EasyBoss ERP保留相關追訴權利。",
            "60j4x24i71g5-1": "3.若您使用“分銷資金”功能，雙方應線下支付錢款，雙方線下資金往來屬獨立民事行爲，由雙方自行履約並承擔風險。EasyBoss ERP僅提供記賬功能，不對雙方資金往來提供清算、分賬及其他資金相關服務，亦不對因此產生的糾紛負責。",
            "60j4x24i71g6-1": "4.分銷商將訂單推送給供應商處理，供應商由於任何原因，導致訂單延遲發貨、取消，由此產生的影響，請供分銷雙方友好解決，EasyBoss ERP不提供任何擔保且對雙方的合作不負有任何義務。",
            "60j4x24i71g7": "5.EasyBoss ERP分銷功能的服務本質是向供應商與分銷商提供技術協作工具，不涉及撮合交易、信用擔保或商業推介。",
            "60j4x24i71b9": "《用戶協議》",
            "60j4x24i71g9-1": "6.其他相關約定詳見EasyBoss ERP",
            "60j4x24i71f2": "分銷合作須知",
            "60j4x24i71f5": "關閉",
            "60j4x24i71f4": "我已充分閱讀並理解"
          }
        }
      },
      "constant": {
        "constant": {
          "distribution": {
            "5yg7j4qkamo0": "合作中",
            "5yg7j4qkb0o0": "供應商已終止",
            "5yg7j4qkb3g0": "分銷商已終止",
            "5yg7j4qkb6c0": "供應商已拒絕",
            "5yg7j4qkb800": "分銷商已拒絕",
            "5yg7j4qkb9s0": "待供應商授權",
            "5yg7j4qkbco0": "待分銷商接受",
            "5yg7j4qkbe80": "待授權",
            "5yg7j4qkbfs0": "已拒絕",
            "5yg7j4qkbhg0": "已終止",
            "5yg7j4qkbht0": "狀態異常",
            "63plc60utxk0": "商品供貨價",
            "63plc60uv040": "商品供貨價和打包費"
          }
        },
        "distribution": {
          "constant": {
            "61qjub0xbi00": "已分銷",
            "61qjub0xbx80": "未分銷",
            "61qjub0xc040": "中國台灣"
          }
        }
      },
      "site": {
        "Distribution": {
          "DistributeBtn": {
            "61qihbill1w0": "我要分銷",
            "61qihbill1g0": "您尚未與供應商:{0}達成合作關系,請達成合作關係後,再操作!",
            "61qihbilleo0": "提示",
            "61qihbillh00": "達成合作關係,請達成合作關係後,再操作!",
            "61qihbillj00": "以後不再提示",
            "61qihbilllg0": "發起合作",
            "61qihbillng0": "關閉",
            "61qihbillpg0": "繼續分銷",
            "61qihbillr00": "取消",
            "61qihbill1g0-1": "確定要將此商品添加至分銷商品列表?",
            "61qihbill1g0-2": "添加後,您可前往{0}電腦端 > 我已分銷的商品列表查看"
          },
          "InviteApplyConfirmPopup": {
            "61qilfdymfs0": "提示",
            "61qilfdymyo0": "您已向供應商:{0}發起合作申請! 請等待供應商審核",
            "61qilfdyn340": "我已知曉"
          },
          "LoginTipsConfirm": {
            "61qihbilh1g0": "登錄",
            "61qihbill1g0-1": "供應商{0}邀請您合作看貨，請先登錄"
          },
          "CoopStatusTipsConfirm": {
            "61qihbillj00-1": "《分銷合作須知》",
            "61qihbill1g0-1": "邀請您與他建立合作，請選擇是否接受合作邀請",
            "61qihbillj00-2": "我已閱讀並同意",
            "61qihbill1g3": "供應商"
          }
        },
        "SkuList": {
          "index": {
            "61qinmmejwo0": "規格列表"
          },
          "SkuItem": {
            "61qioccekzk0": "庫存",
            "61qioccelhw0": "供貨價"
          }
        },
        "components": {
          "AttributeInfo": {
            "61qiz6nds7c0": "商品屬性",
            "61qiz6ndsls0": "類目",
            "61qiz6ndspg0": "分銷地區",
            "61qiz6ndsss0": "包裹重量",
            "61qiz6ndsv80": "包裹尺寸",
            "61qiz6ndsxw0": "供應商展架",
            "61qiz6ndt0g0": "不限"
          },
          "RichNotes": {
            "61qj2yrwj600": "詳細描述"
          },
          "ShortNotes": {
            "61qj3nr7t3k0": "簡易描述"
          },
          "MainPlatformsList": {
            "61qj5zmp8r40": "更多平台"
          },
          "DateTimePick": {
            "61qjpwjkg8o0": "開始時間",
            "61qjpwjkgr80": "結束時間"
          },
          "BaseInfo": {
            "61qj1kkx0lw0-2": "近七天銷量 {0}",
            "61qj1kkx12s0-2": "月銷 {0}"
          },
          "CertifiedInfo": {
            "69tbtcoo7280": "企業信息",
            "69tbtcoo86k0": "企業認證",
            "69tbtcoo8dg0": "暫未認證",
            "69tbtcoo8g00": "聯繫人姓名",
            "69tbtcoo8lk0": "聯繫人手機",
            "69tbtcoo8o40": "聯繫方式二維碼",
            "69tbtcoo8qg0": "查看",
            "69tbtcoo8uk0": "關閉"
          },
          "CertificationInfoRow": {
            "6bee3rgrz500": "供應商企業信息：",
            "6bee3rgrzfg0": "未認證",
            "6bee3rgrzhs0": "企業認證",
            "6bee3rgrzjc0": "暫未認證",
            "6bee3rgrzks0": "聯繫人姓名：",
            "6bee3rgrzmg0": "聯繫人手機："
          }
        },
        "supplier": {
          "index": {
            "61qj6pgipk80": "主營類目",
            "61qj6pgipxg0": "主營平台",
            "61qj6pgipzs0": "聯系方式",
            "61qj6pgiq1g0": "發貨地",
            "61qj6pgiq340": "簡介",
            "61qj6pgiq4w0": "服務能力:",
            "61qj6pgiq840": "分銷訂單48h發貨率",
            "61qj6pgiq4j0": "商品能力:",
            "61qj6pgiqbc0": "可分銷商品",
            "61qj6pgiqec0": "近30天上新",
            "61qj6pgiqg40": "平均分銷價",
            "61qj6pgiq9o0-1": "分銷商數",
            "61qj6pgiq6k0-1": "日均發貨數"
          }
        },
        "Category": {
          "CategoryPopup": {
            "61qjaj2r6r40": "類目選擇",
            "61qjaj2rals0": "確定選中"
          },
          "ChildrenTree": {
            "61qjbnuzf9k0": "全部",
            "61qjbnuzf9k4-0": "類目選項",
            "61qjbnuzf9k4-1": "一級選項",
            "61qjbnuzf9k4-2": "二級選項",
            "61qjbnuzf9k4-3": "三級選項",
            "61qjbnuzf9k4-4": "四級選項",
            "61qjbnuzf9k4-5": "五級選項",
            "61qjbnuzf9k4-6": "六級選項",
            "61qjbnuzf9k4-7": "七級選項",
            "61qjbnuzf9k4-8": "八級選項",
            "61qjbnuzf9k4-9": "九級選項"
          },
          "index": {
            "61qjd2qzs340": "更多篩選"
          }
        },
        "DistributionFilter": {
          "FilterDetailPopup": {
            "61qjg2lg1000": "類目",
            "61qjg2lg1io0": "請選擇類目",
            "61qjg2lg1mo0": "展架",
            "61qjg2lg1pg0": "上新時間",
            "61qjg2lg1ro0": "供貨價",
            "61qjg2lg1u80": "最低供貨價",
            "61qjg2lg1yc0": "最高供貨價",
            "61qjg2lg2100": "重置",
            "61qjg2lg23g0": "查詢"
          },
          "index": {
            "61qjjlbaqc40": "篩選"
          }
        },
        "hooks": {
          "useDistributionSite": {
            "61qjqy9ef800": "全部",
            "61qjqy9efks0": "請選擇要分銷的商品",
            "61qjqy9efmw0": "操作成功",
            "61qjqy9efkf0": "{0}-分銷小站"
          },
          "useDistributionBind": {
            "5yg2wlqzuo01": "請閱讀並同意分銷合作須知"
          }
        },
        "site": {
          "index": {
            "61qjsg77ovk0": "商品名稱",
            "61qjsg77p8o0": "發起合作申請",
            "61qjsg77pas0": "接受邀請"
          }
        },
        "DistributionGoodsList": {
          "GoodItem": {
            "61qjl9nof8c0-1": "庫存 {0}",
            "61qjl9nof8c6-1": "月銷 {0}"
          }
        },
        "CustomCategory": {
          "CategoryRow": {
            "61qjdxb7n900-0": "展架分類",
            "61qjdxb7n900-1": "一級展架",
            "61qjdxb7n900-2": "二級展架",
            "61qjdxb7n900-3": "三級展架",
            "61qjdxb7n900-4": "四級展架",
            "61qjdxb7n900-5": "五級展架",
            "61qjdxb7n900-6": "六級展架",
            "61qjdxb7n900-7": "七級展架",
            "61qjdxb7n900-8": "八級展架",
            "61qjdxb7n900-9": "九級展架"
          }
        },
        "goodsDetail": {
          "index": {
            "61qj4ddmz640-1": "關閉",
            "61qj4ddmz640": "商品詳情"
          }
        },
        "siteRelay": {
          "index": {
            "62xo50y17h00": "提示",
            "62xo50y18400": "請確認您的邀請鏈接是否正確",
            "62xo50y18a80": "確認",
            "62xo50y184c6": "請在手機微信中掃碼打開",
            "62xo50y184v7": "供應商{0}邀請您與他建立合作"
          }
        }
      }
    },
    "my": {
      "my": {
        "components": {
          "InputAutoFocusSettingSelect": {
            "5yjh4axepj00": "輸入框自動聚焦"
          },
          "MessageSetting": {
            "5wsk1gq11gsq": "消息設置",
            "5wsk1gq11gsq-0": "安全庫存預警",
            "5wsk1gq11gsq-1": "開啟後,每日10:00推送安全庫存預警通知",
            "5wsk1gq11gsq-2": "正在保存..."
          },
          "ScanShipmentSettingSelect": {
            "5wsklmc59bk0": "掃描發貨"
          }
        }
      },
      "myIndex": {
        "5rnxe856up00": "個人中心",
        "5rnxe856vpg0": "貨代版",
        "5rnxe856vw00": "免費版",
        "5rnxe856vzo0": "付費版",
        "5rnxe856w380": "倉庫",
        "5rnxe856w780": "掃描方式",
        "5rnxe856wao0": "退出登錄",
        "5rnxe856whs0": "確認要退出登錄嗎?",
        "5rnxe856wq40": "語種",
        "5rnxe856wv40": "切換語言需要重啟應用",
        "5rnxe856wha0": "掃描發貨設置",
        "5rnxe856whb0": "加載中",
        "5rnxe856whb1": "使用相機掃描時,請不要再按壓激光掃描按鈕,設備可能會卡住",
        "5rnxe856whb2": "輸入框自動聚焦",
        "5rnxe856wbx2": "前往登錄>",
        "my": {
          "index": {
            "936518-0": "消息設置"
          }
        }
      }
    },
    "permission": {
      "404": {
        "60cyyf5ngl80": "暫無權限",
        "60cyyf5nhjo0": "暫無權限，請聯繫主帳號添加"
      }
    },
    "stat": {
      "HotGoodsSection": {
        "constant": {
          "5zmqkoscpn00": "按SKU(單品)",
          "5zmqkoscqlo0": "按SPU(產品)"
        },
        "index": {
          "5zmr5k20gnk0": "熱銷產品TOP10",
          "5zmr5k20i840": "規格",
          "5zmr5k20ifs0": "平台SKU",
          "5zmr5k20ikg0": "產品ID",
          "5zmr5k20iok0": "主貨號",
          "5zmr5k20it00": "店鋪",
          "5zmr5k20ixc0": "銷售額",
          "5zmr5k20j1g0": "銷量"
        }
      },
      "HotPlatformSection": {
        "index": {
          "5zmr5t9re380": "熱銷平台TOP5",
          "5zmr5t9rf3o0": "排名",
          "5zmr5t9rf7k0": "平台",
          "5zmr5t9rf9s0": "銷售額"
        }
      },
      "HotShopSection": {
        "index": {
          "5zmr60rhpes0": "熱銷店鋪TOP5",
          "5zmr60rhpyk0": "排名",
          "5zmr60rhq100": "店鋪",
          "5zmr60rhq300": "平台",
          "5zmr60rhq4k0": "銷售額"
        }
      },
      "StatShopSelect": {
        "index": {
          "5zmr8nz3oa40": "選擇平台",
          "5zmr8nz3pac0": "選擇站點",
          "5zmr8nz3pio0": "選擇店鋪"
        }
      },
      "TotalViewSection": {
        "constant": {
          "5zmqmu4tw1g0": "付款總額",
          "5zmqmu4twh40": "預計實收",
          "5zmqmu4twks0": "付款客戶數",
          "5zmqmu4twns0": "較昨日",
          "5zmqmu4twq80": "付款訂單量",
          "5zmqmu4twuk0": "退款客戶數",
          "5zmqmu4twx00": "退款訂單量",
          "5zmqmu4twzg0": "退款總額",
          "5zmqmu4tx3o0": "預估利潤",
          "5zmqmu4tx6g0": "利潤率"
        },
        "index": {
          "5zmr673frbk0": "當日數據，2小時更新一次"
        }
      },
      "common": {
        "60a99nlkohc0": "利潤明細",
        "60a9dq4u54g0": "商品銷售",
        "60a9d45degg0": "產品統計",
        "60a9eurfpww0": "包材統計",
        "60a9feawjog0": "店鋪統計",
        "60a9ht0fpgc0": "日期篩選",
        "60a9lb8cd0w0": "貨幣單位",
        "60a9lb8cdko0": "按訂單狀態",
        "60a9rrnp5rs0": "數據統計",
        "5saylxfm3ps0": "最大區間為3個月,請重新選擇查詢時間"
      },
      "components": {
        "CoreIndicator": {
          "5zmr3p5s6280": "核心指標",
          "5zmr3p5s6s40": "銷售額"
        },
        "CoreIndicatorChart": {
          "5zmr3x26fdo0": "核心指標趨勢",
          "5zmr3x26g500": "產品統計",
          "5zmr3x26g8g0": "百分比(%)"
        },
        "DataStatisticsSection": {
          "5zmr2qhmwkw0": "數據統計"
        },
        "DisbursementChartCard": {
          "5zmr43sgo9o0": "支出分析",
          "5zmr43sgomg0": "{0}佔比: {1}%",
          "5zmr43sgopc0": "總支出"
        },
        "GoodsItemSection": {
          "5zmr895tvq80": "商品SKU",
          "60kms1u2s700": "規格"
        },
        "GoodsSection": {
          "5zmr2yq2c0k0": "產品ID",
          "5zmr2yq2cek0": "主貨號",
          "5zmr2yq2ch80": "平台",
          "5zmr2yq2cj00": "店鋪",
          "5zmr2yq2ckk0": "付款訂單量",
          "5zmr2yq2cm80": "銷量",
          "5zmr2yq2cns0": "總付款金額",
          "5zmr2yq2cpc0": "總退款金額",
          "5zmr2yq2cr00": "規格",
          "5zmr2yq2css0": "平台SKU"
        },
        "OrderDistributionSection": {
          "5zmr7cert4c0": "付款訂單分佈"
        },
        "ProductDistributionSection": {
          "5zmr36t00b80": "有銷量的產品分佈"
        },
        "RankingTenList": {
          "5zmr4euc2940": "利潤分析TOP10",
          "5zmr4euc2z40": "排名",
          "5zmr4euc3300": "利潤",
          "5zmr4euc35s0": "銷售額",
          "5zmr4euc3880": "銷售利潤率",
          "5zmr4euc3bs0": "總利潤"
        },
        "StatDropdown": {
          "5zmr95mf3q00": "已選擇",
          "5zwtjniwy940": "個"
        },
        "StatSearchBar": {
          "5zmr9lrwj5g0": "請輸入",
          "5zmr9lrwknc0": "篩選"
        },
        "TableSection": {
          "5zmr7j0011s0": "日期",
          "5zmr7j001yw0": "客戶數",
          "5zmr7j002340": "訂單量",
          "5zmr7j0028s0": "退款金額",
          "5zmr7j002680-1": "銷售額"
        },
        "StatDetailPopup": {
          "5zmw7ihk8580": "重置",
          "5zmw7ihk9n80": "確定"
        },
        "QueryBar": {
          "5saylxfm3p80": "最大區間為3個月,請重新選擇查詢時間",
          "5saylxfm4400": "僅支持查詢近3個月的數據,請重新選擇查詢時間"
        },
        "StatRadio": {
          "60aa4y1tqd40": "已選擇",
          "60aa4y1tqq80": "個",
          "60aa4y1tqss0": "全部"
        },
        "StatEmpty": {
          "60krhr1rgwk0": "暫無數據"
        }
      },
      "constant": {
        "5zmp81p6xo00": "付款訂單量",
        "5zmp81p6yuk0": "總付款金額",
        "5zmp81p6yzs0": "退款訂單量",
        "5zmp81p6z2w0": "總退款金額",
        "5zmp81p6z5s0": "數據總覽",
        "5zmp81p6z9k0": "利潤概覽",
        "5zmp81p6zcg0": "利潤明細",
        "5zmp81p6zlk0": "產品統計",
        "5zmp81p6zug0": "銷量統計",
        "5zmp81p70840": "訂單統計",
        "5zmp81p70fk0": "店鋪統計",
        "5zmp81p70j80": "商品銷售",
        "5zmp81p70lg0": "進出統計",
        "5zmp81p70o00": "包材統計",
        "5zmp81p70q40": "按天",
        "5zmp81p70sc0": "按周",
        "5zmp81p70uk0": "按月",
        "5zmp81p70wg0": "昨天",
        "5zmp81p70y80": "近7天",
        "5zmp81p710g0": "近30天",
        "5zmp81p713o0": "自訂日期",
        "5zmp81p715c0": "退款金額",
        "5zmp81p719c0": "下單時間",
        "5zmp81p71b00": "結算時間",
        "5zmp81p71dk0": "付款時間",
        "5zmp81p71f80": "發貨時間",
        "5zmp81p71jg0": "截至發貨",
        "5zmp81p71ok0": "銷售額",
        "5zmp81p71rg0": "預估回款金額",
        "5zmp81p71t80": "買家實付",
        "5zmp81p71v40": "商品成本",
        "5zmp81p71ws0": "其他成本",
        "5zmp81p71yg0": "包材費",
        "5zmp81p71zs0": "利潤",
        "5zmp81p72180": "成本利潤率",
        "5zmp81p72340": "銷售利潤率",
        "5zmp81p724w0": "按平台",
        "5zmp81p726c0": "按站點",
        "5zmp81p72800": "按店鋪",
        "5zmp81p729c0": "店鋪",
        "5zmp81p72aw0": "平台",
        "5zmp81p72f00": "站點",
        "6021uie62280": "銷量",
        "668une5n9xs0": "分銷訂單量",
        "668une5nah40": "退款分銷訂單",
        "668une5nalc0": "退款分銷金額"
      },
      "hooks": {
        "5zmp74as2c00": "加載中"
      },
      "incomeAndExpenditureStatistics": {
        "constant": {
          "5zmqp7c2t700": "期末庫存",
          "5zmqp7c2u6c0": "期初庫存",
          "5zmqp7c2udo0": "採購入庫",
          "5zmqp7c2uhw0": "庫存調整入庫",
          "5zmqp7c2ulk0": "盤盈入庫",
          "5zmqp7c2uq80": "調撥入庫",
          "5zmqp7c2uu80": "退貨入庫",
          "5zmqp7c2uyg0": "手工退貨入庫",
          "5zmqp7c2v3o0": "其他入庫",
          "5zmqp7c2v800": "銷售出庫",
          "5zmqp7c2vc40": "庫存調整出庫",
          "5zmqp7c2vgg0": "盤虧出庫",
          "5zmqp7c2vkw0": "調撥出庫",
          "5zmqp7c2vp40": "手工銷售出庫",
          "5zmqp7c2vtk0": "其他出庫",
          "5zmqp7c2vzw0": "商品SKU",
          "5zmqp7c2w480": "商品名稱"
        },
        "hooks": {
          "5zmr7yzqthc0": "日期篩選",
          "5zmr7yzqtsw0": "選擇倉庫"
        },
        "index": {
          "5zmr7qd04is0": "出入統計"
        }
      },
      "index": {
        "5zmp4zbj9s00": "實時數據",
        "5zmp4zbjazc0": "當日數據，每2小時更新一次",
        "5zmp4zbjb3k0": "常用功能",
        "5zmvhhwoxlw0": "貨幣單位",
        "668uopimypk0": "分銷數據"
      },
      "orderDetail": {
        "constant": {
          "60a9oxflttc0": "訂單收入",
          "60a9oxflu740": "訂單原始金額",
          "60a9oxflu9o0": "產品價格",
          "60a9oxfluc40": "總運費",
          "60a9oxfluds0": "買家支付的運費",
          "60a9oxflufk0": "賣家支付的運費",
          "60a9oxfluhc0": "折扣",
          "60a9oxfluiw0": "費用與收費",
          "60a9oxfluko0": "佣金",
          "60a9oxflum40": "服務費",
          "60a9oxflunw0": "交易手續費",
          "60a9oxflupk0": "買家實付金額",
          "60a9oxflur40": "運費",
          "60a9oxflut80": "包材費",
          "60a9oxfluus0": "其他成本",
          "60a9oxfluwg0": "商品成本",
          "60a9oxfluyc0": "預估利潤",
          "60a9pmw41sg0": "Shopee運費補貼",
          "60a9qjl9dao0": "賣家優惠券",
          "60a9qtr2gzk0": "Shopee幣抵扣"
        },
        "index": {
          "60a9ncf9km00": "訂單明細",
          "60a9ncf9kys0": "訂單號碼：",
          "60a9ncf9l180": "當前金額單位：",
          "60a9ncf9l2w0": "站點：",
          "60a9ncf9l4o0": "匯率："
        },
        "orderDetail": {
          "hooks": {
            "68q0fui6cm00": "訂單金額",
            "68q0fui6dk00": "優惠",
            "68q0fui6dq40": "買家運費",
            "68q0fui6dv00": "商家運費",
            "68q0fui6dz80": "平臺佣金",
            "68q0fui6e380": "平臺佣金(預估)",
            "68q0fui6e7c0": "稅費",
            "68q0fui6eb80": "實付金額",
            "68q0fui6efc0": "回款金額",
            "68q0fui6eps0": "回款金額(預估)",
            "68q0fui6f000": "採購金額",
            "68q0fui6f4o0": "倉庫操作費",
            "68q0fui6f7w0": "利潤",
            "68q0fui6fao0": "利潤(預估)",
            "68q0fui6fds0": "成本利潤率",
            "68q0fui6fgg0": "銷售利潤率"
          }
        }
      },
      "orderStatistics": {
        "constant": {
          "5zmqukt4k5w0": "按店鋪",
          "5zmqukt4loo0": "價格區間",
          "5zmqukt4lu40": "日期",
          "5zmqukt4ly80": "客戶數（個）",
          "5zmqukt4m1s0": "訂單量（筆）",
          "5zmqukt4mcw0": "付款訂單量（筆）",
          "5zmqukt4mfo0": "付款客戶數（個）",
          "5zmqukt4mi40": "退款總額",
          "5zmqukt4mlw0": "退款訂單量（筆）",
          "5zmqukt4mqs0": "退款客戶數（個）",
          "5zmqukt4muc0": "客单價",
          "5zmqukt4nj40": "有效訂單量",
          "5zmqukt4o100": "有效銷售額",
          "5zmqukt4o134": "{0}個SKU品類",
          "5zmqukt4o155": "{0}個SKU品類及以上",
          "5zmqukt4o177": "SKU品類數",
          "5zmqukt4m600-1": "銷售額"
        },
        "hooks": {
          "5zmr6ze850o0": "日期篩選"
        },
        "index": {
          "5zmr6pphrw00": "訂單統計",
          "5zmr6pphsek0": "篩選",
          "5zmr6pphsi40": "數據指標趨勢圖"
        }
      },
      "overview": {
        "constant": {
          "5zmqj6xm7gs0": "實時數據",
          "5zmqj6xm8840": "熱銷平台",
          "5zmqj6xm8bs0": "熱銷店鋪",
          "5zmqj6xm8ec0": "熱銷產品"
        },
        "index": {
          "5zmr4qhws3s0": "數據總覽"
        }
      },
      "packagingMaterialsStatistics": {
        "components": {
          "60aa48gpg940": "數據統計"
        },
        "constant": {
          "60aa3i4w8840": "包材總數",
          "60aa3i4w8mk0": "訂單使用量",
          "60aa3i4w91s0": "總金額",
          "60aa3i4w9940": "編碼",
          "60aa3i4w9b00": "名稱",
          "60aa3i4w9cs0": "排名",
          "60aa3i4w9e80": "平均單價",
          "60aa3i4w9g00": "小計"
        }
      },
      "productSales": {
        "components": {
          "60aa1gn2j3o0": "規格",
          "60aa1gn2jms0": "商品SKU",
          "60aa24ijr500": "數據統計"
        },
        "constant": {
          "60aa0cmsgck0": "商品種類",
          "60aa0cmsgwk0": "商品銷量",
          "60aa0cmsh000": "商品成本",
          "60aa0cmsh280": "退貨數量",
          "60aa0cmsh4g0": "退款金額",
          "60aa0cmsh780": "銷售金額",
          "60aa0cmsh9s0": "退款成本",
          "60aa0cmshbw0": "銷售訂單量",
          "60aa0vmcdtw0": "商品SKU",
          "60aa0vmcec00": "商品名稱",
          "66nz0gm6nck0": "組合SKU按子SKU統計",
          "66nz0gm6scw0": "組合SKU獨立統計"
        }
      },
      "productStatistics": {
        "components": {
          "60a9yyz55n00": "數據指標趨勢圖",
          "60a9yyz565o0": "百分比(%)"
        },
        "constants": {
          "60a9xumyah40": "日期",
          "60a9xumyav40": "產品總數",
          "60a9xumyay40": "在售產品數",
          "60a9xumyb000": "在售產品佔比",
          "60a9xumyb1s0": "有銷量產品數",
          "60a9xumyb5k0": "動銷率",
          "60a9xumyb740": "新增在售產品數",
          "60a9xumyb8s0": "新增在售產品佔比"
        }
      },
      "profitDetail": {
        "components": {
          "60a9u37djso0": "訂單明細",
          "60a9u37dkc40": "店鋪明細",
          "60a9vuvtmfs0": "店鋪：",
          "60a9vuvtms80": "站點：",
          "60a9wn2oggk0": "產品ID",
          "60a9wn2ogv80": "平台SKU",
          "60a9wn2ogz40": "商品SKU",
          "60a9wn2oh1s0": "商品成本",
          "60a9wn2oh4s0": "平台回款金額：",
          "60a9wn2oh7g0": "利潤：",
          "60a9wn2oha00": "銷售利潤率："
        },
        "constant": {
          "60a9mn7mnho0": "按訂單明細",
          "60a9mn7mo0g0": "按店鋪",
          "60a9mn7mo4c0": "訂單號碼",
          "60a9mn7mo780": "包裹號碼",
          "60a9mn7mo9g0": "運單號碼",
          "60a9mn7mod80": "產品標題",
          "60a9mn7mofk0": "產品ID",
          "60a9mn7mohs0": "平台SKU",
          "60a9mn7mok40": "商品SKU",
          "60a9mn7momg0": "下單時間",
          "60a9mn7mook0": "結算時間",
          "60a9mn7mor40": "付款時間",
          "60a9mn7mouc0": "發貨時間",
          "60a9mn7moww0": "截止發貨時間",
          "60a9skxqv140": "訂單數量",
          "60a9skxqvhc0": "銷售額",
          "60a9skxqvko0": "買家實付",
          "60a9skxqvn80": "預估回款金額",
          "60a9skxqvpo0": "已結算金額",
          "60a9skxqvs00": "待結算金額",
          "60a9skxqvug0": "成本",
          "60a9skxqvyo0": "商品成本",
          "60a9skxqw0o0": "廣告成本",
          "60a9skxqw380": "運營成本",
          "60a9skxqw5g0": "包材成本",
          "60a9skxqw7w0": "其他成本",
          "60a9skxqwbg0": "利潤",
          "60a9skxqwdw0": "成本利潤率",
          "60a9skxqwgg0": "銷售利潤率",
          "60a9skxqwiw0": "今日數據",
          "60a9skxqwl40": "昨日數據",
          "60a9skxqwnw0": "匯總數據",
          "60a9v7pp1n00": "預估回款金額",
          "60a9v7pp2qs0": "訂單原始金額",
          "60a9v7pp30g0": "買家實付",
          "60a9v7pp33g0": "包材費",
          "60a9v7pp3680": "其他成本",
          "60a9v7pp38w0": "利潤",
          "60a9v7pp3bo0": "成本利潤率",
          "60a9v7pp3fo0": "銷售利潤率",
          "60y9bytj9u80": "第三方倉操作費",
          "60y9bytjb480": "第三方倉運費"
        }
      },
      "profitsOverview": {
        "constant": {
          "5zmqie08y6k0": "核心指標",
          "5zmqie08yp40": "核心指標趨勢",
          "5zmqie08ytg0": "支出分析",
          "5zmqie08ywk0": "利潤分析",
          "5zmqie08yzo0": "平台回款金額",
          "5zmqie08z2o0": "環比",
          "5zmqie08z5c0": "包材費",
          "5zmqie08z7w0": "買家實付",
          "5zmqie08zak0": "利潤",
          "5zmqie08zd40": "商品成本",
          "5zmqie08zfo0": "成本利潤率",
          "5zmqie08zig0": "其他成本",
          "5zmqie08zks0": "銷售利潤率"
        },
        "index": {
          "5zmr3g7jskw0": "利潤概覽"
        }
      },
      "saleDetail": {
        "index": {
          "5zmr52c50ng0": "數據總覽",
          "5zmr52c517g0": "產品銷量統計詳情",
          "5zmr52c51bk0": "數據指標趨勢圖",
          "5zmvji9oxrk0": "產品ID",
          "5zmvji9oz0w0": "平台SKU",
          "5zmvji9oz700": "平台",
          "5zmvji9ozao0": "店鋪",
          "5zmvjnye99g0": "產品維度",
          "5zmvlw6cgzg0": "規格",
          "603i2ug6f3k0": "開始時間",
          "603i2ug6gbs0": "結束時間",
          "603i2ug6gjc0": "僅支持查詢近6個月的數據,請重新選擇查詢時間"
        }
      },
      "salesStatistics": {
        "constant": {
          "5zmqf0amgts0": "按SPU(產品)",
          "5zmqf0ami0c0": "按SKU(單品)",
          "5zmqf0ami6o0": "按店鋪",
          "5zmqf0amib40": "價格區間",
          "5zmqf0amifc0": "銷售區間",
          "5zmqf0amilc0": "產品總數",
          "5zmqf0amiqg0": "付款訂單量",
          "5zmqf0amiuo0": "銷量",
          "5zmqf0amj000": "付款總額",
          "5zmqf0amj440": "退款訂單量",
          "5zmqf0amj8c0": "退款金額",
          "5zmqf0amjcw0": "產品標題",
          "5zmqf0amjhc0": "產品ID",
          "5zmqf0amjkw0": "平台SKU"
        },
        "hooks": {
          "5zmr1xvtlyw0": "日期篩選"
        },
        "index": {
          "5zmr18mjbic0": "銷量統計"
        }
      },
      "shopStatistics": {
        "components": {
          "60a9ixf7pqs0": "店鋪明細",
          "60a9ixf7q7w0": "店鋪：",
          "60a9ixf7qcg0": "客戶數(個)：",
          "60a9ixf7qfc0": "訂單量(筆)：",
          "60aacanra200": "數據統計"
        },
        "constant": {
          "60a9gbqw2w80": "客戶數(個)",
          "60a9gbqw3os0": "訂單量(筆)",
          "60a9gbqw3sk0": "訂單總額",
          "60a9gbqw3v80": "付款總額",
          "60a9gbqw3xg0": "退款金額",
          "60a9gbqw3zw0": "客单價",
          "60a9gbqw42c0": "付款訂單量",
          "60a9gbqw4d40": "付款客戶數(個)",
          "60a9gbqw4i40": "退款訂單量",
          "60a9gbqw4po0": "退款客戶數(個)"
        }
      }
    },
    "warehouse": {
      "baseIndex": {
        "5wfvehrixdc0": "今日已入庫包裹",
        "5wfvehrixtk0": "今日已上架SKU",
        "5wfvehrj1ts0": "請選擇倉庫",
        "5wfvehrj1zs0": "簽收入庫",
        "5wfvehrj24w0": "手工入庫",
        "5wfvehrj29k0": "手工出庫",
        "5wfvehrj2ng0": "商品查詢",
        "5wfvehriixa0": "倉庫",
        "5wfvehrj2na0": "掃描發貨",
        "61s2n6t0kpc0": "掃描驗貨",
        "619ereolw8g0": "退貨入庫",
        "62xp0659vcg0": "掃描查單",
        "5wfvehrj2ig0-1": "波次揀貨",
        "warehouse": {
          "index": {
            "944251-0": "今日已出庫SKU",
            "944251-1": "今日低庫存SKU"
          }
        }
      },
      "components": {
        "packageItem": {
          "5rnxjrj9pt00": "請輸入/掃描物流單號、採購單號",
          "5rnxl2uge480": "待入庫數",
          "5rnxl2ugey80": "備註",
          "5rnxaw89ng9q": "採購數量",
          "5rnxaw89ng9q-1": "SKU種類",
          "5rnxaw89ng9q-2": "收貨倉庫",
          "5rnxaw89ng9q-3": "創建時間",
          "5rnxaw89ng9q-4": "備註",
          "5rnxaw89ng9q-5": "退貨數量"
        }
      },
      "goodsSearch": {
        "baseIndex": {
          "5weqyxxhmtg0": "商品查詢",
          "5weqyxxhnfg0": "掃描商品SKU/商品代碼",
          "5weqyxxhnjw0": "請掃描商品信息",
          "5weqyxxhnms0": "請輸入商品SKU/商品代碼",
          "5weqyxxhnpk0": "加載中",
          "5weqyxxhnsk0": "未查到此商品"
        },
        "components": {
          "GoodsCard": {
            "GoodsInfo": {
              "5wer21zf7rk0": "商品代碼",
              "5wer21zf8jg0": "近7/30/60天銷量"
            },
            "index": {
              "5wer2vtlaf40": "子商品"
            },
            "StorageInfo": {
              "5wer3yv4lx40": "倉位",
              "5wer3yv4mgo0": "庫存總量",
              "5wer3yv4o8g0": "可用",
              "5wer3yv4ofw0": "預佔"
            }
          }
        }
      },
      "processStorage": {
        "baseIndex": {
          "5rny2tblyc00": "掃描商品",
          "5rny2tblz7g0": "請輸入/掃描商品SKU、商品代碼",
          "5rny2tblzds0": "結束本次入庫",
          "5rny2tblzkw0": "出庫",
          "5rny2tblzps0": "入庫",
          "5rny2tblztk0": "未找到商品",
          "5rny2tblzx00": "組合品不可入庫",
          "5rny2tbm00g0": "加載中",
          "5rny3yibbno0": "成功",
          "5rny51km7e40": "出庫數量不能超過",
          "5rolykv54d00": "請輸入商品SKU"
        },
        "components": {
          "GoodsPopup": {
            "5rnxodldrdc0": "種",
            "5rnxodlds640": "件",
            "5rnxodldsdc0": "提交"
          },
          "SetQuantityDialog": {
            "5rnxpb2qwsg0": "請輸入數量",
            "5rnxu9u7r2c0": "本次",
            "5ron09jvyh80": "數",
            "5rnxpb2qxg00": "數量不能爲空",
            "5rnxu9u7q4w0": "數量不能超過"
          }
        },
        "processGoodsWithStoragePage": {
          "baseIndex": {
            "5rnxzgpf7i00": "商品",
            "5rnxzgpf8co0": "名稱:",
            "5rnxzgpf8io0": "規格:",
            "5rnxzgpf8mg0": "待入庫數:",
            "5rnxzgpf8q40": "本次",
            "5rnxzgpf8tk0": "無倉位",
            "5rnxzgpf8ww0": "未選擇倉位",
            "5rnxzgpf90g0": "刪除",
            "5rnxzgpf93s0": "換倉位",
            "5rnxzgpf97c0": "出庫",
            "5rnxzgpf9ao0": "入庫",
            "5rnxzgpf9e80": "倉位不能為空,請檢查倉位",
            "5rnxzgpf9hs0": "正在操作",
            "5rnxzgpf9l80": "數據異常,請聯系客服",
            "5rny0rcmwbk0": "正在",
            "5werec5q0lc0": "確定",
            "5werang0qn9a": "掃描商品入庫",
            "5weranuqn9nm": "採購數量",
            "5werawjh091m": "已入庫數",
            "5wednf0n1a6m": "待入庫數",
            "5wedn1n98ntr": "本次入庫",
            "5wednq9h81nb": "倉位",
            "5wednawjnfg9": "退貨數量",
            "5uz50t6c8vc1": "分銷商退貨單入庫處理後，自動退還:"
          }
        },
        "scanStorageCellPage": {
          "baseIndex": {
            "5rny1og9cek0": "掃描倉位",
            "5rny1og9d740": "請掃描/輸入倉位號",
            "5rny1og9ddc0": "請掃描倉位",
            "5rny1og9dgw0": "正在查詢",
            "5roninktevk0": "該商品在此倉位無庫存"
          }
        }
      },
      "putaway": {
        "baseIndex": {
          "5rnyj390bf00": "掃描包裹",
          "5rnyj390c1o0": "請輸入/掃描物流單號、採購單號",
          "5rnxm6vsad80": "請掃描包裹",
          "5rnyj390c7g0": "待簽收採購單",
          "5rnyj390cb40": "加載中",
          "5rnyj390ce80": "暫無數據",
          "5rnyj390cho0": "採購單簽收成功"
        },
        "components": {
          "WaitReceivePurchaseOrderList": {
            "5rnyh09ydbg0": "暫無數據"
          }
        },
        "purchaseOrderInfoPage": {
          "baseIndex": {
            "5rnyibnc0h40": "掃描包裹",
            "5rnyibnc14g0": "名稱:",
            "5rnyibnc1a00": "規格:",
            "5rnyibnc1dw0": "代碼：",
            "5rnyibnc1hc0": "已經到底啦",
            "5rnyibnc1l00": "直接入庫",
            "5rnyibnc1ow0": "掃描商品入庫",
            "5rnyibnc1sg0": "直接入庫後,庫存將增加,確定入庫?",
            "5rnyibnc1w80": "正在入庫中...",
            "5rnyianfi9qa-0": "採購數量",
            "5rnyianfi9qa-1": "已入庫數",
            "5rnyianfi9qa-2": "待入庫數",
            "5rnyianfi9qa-3": "倉位",
            "5rnyianfi9qa-4": "無倉位",
            "5rnyianfi9qa-5": "本次入庫",
            "5rnyianfi9qa-6": "當前採購單SKU存在入庫數量大於待入庫數量，確認收貨併入庫嗎？"
          }
        },
        "scanStorageCellPage": {
          "baseIndex": {
            "5rny1aaogj0q-0": "掃描倉位",
            "5rny1aaogj0q-1": "請掃描/輸入倉位號",
            "5rny1aaogj0q-3": "正在查詢",
            "5rny1aaogj0q-4": "暫無數據",
            "5rny1aaogj0q-5": "全部狀態",
            "5rny1aaogj0q-6": "請選擇狀態"
          }
        }
      },
      "scanInspection": {
        "components": {
          "GoBackConfirmPopup": {
            "61x928ywr8g0": "返回將會清空數據,確定返回?"
          },
          "LogisticsGroupPopup": {
            "61s2ulkrbng0": "請選擇物流"
          },
          "PackageInfoContainer": {
            "61s2u6o99vg0": "買家留言",
            "61s2u6o9ad40": "商家備註",
            "61s2u6o9ag40": "本地備註",
            "61s2u6o9ahw0": "商品SKU",
            "61s2u6o9ak00": "商品數量",
            "61s2u6o9als0": "已校驗"
          },
          "ResetConfirmPopup": {
            "61s2tn0lhys0": "保存後,會清空當前已掃描包裹信息,確定繼續?",
            "61s2tn0lifc0": "暫不保存",
            "61s2tn0liig0": "繼續保存"
          },
          "ScanSettingPopup": {
            "61s2t7h33f00": "掃描設置",
            "61s2t7h348w0": "驗貨成功後,自动发货",
            "61s2t7h34e40": "保存"
          }
        },
        "constant": {
          "61s2rr94jzk0": "掃描商品SKU/GTIN",
          "61s2rr94g7o0": "掃描或輸入包裹號/運單號"
        },
        "hooks": {
          "useLogisticsGroupList": {
            "61s2s5zka4k0": "全部物流"
          },
          "useScanInspection": {
            "61s2sk0fjss0": "當前掃描包裹已完成校驗",
            "61s2sk0fnpk0": "加載中",
            "61s2sk0fnwg0": "包裹內無該商品",
            "61s2sk0fo0w0": "該商品已完成校驗",
            "61s2sk0fo4o0": "發貨中",
            "61s2sk0fo840": "部分商品正在盤點,盤點結束後,將自動扣減預占庫存",
            "61s2sk0fob00": "發貨失敗",
            "61s2sk0fod40": "發貨成功",
            "61s2sk0fofs0": "保存中",
            "61wcj39boc80": "未搜到該包裹或訂單包裹已發貨",
            "62hjyf276wk0": "掃描驗貨成功"
          }
        },
        "index": {
          "61s2pxoyy5s0": "掃描驗貨",
          "61s2pxoz2380": "設置",
          "61s2pxoz29w0": "記錄",
          "61s2pxoz2ds0": "請掃描包裹信息"
        },
        "verifiedListPage": {
          "index": {
            "61s304k9b880": "已校驗記錄",
            "61s304k9cfo0": "訂單號/包裹號/物流方式/運單號",
            "61s304k9cm40": "包裹號碼",
            "61s304k9cos0": "訂單號碼",
            "61s304k9d7g0": "物流信息",
            "61s304k9dck0": "發貨狀態",
            "61s304k9dkw0": "全部",
            "61s304k9dno0": "發貨成功",
            "61s304k9dqc0": "發貨失敗"
          }
        }
      },
      "scanReturn": {
        "components": {
          "WaitReturnGoodsList": {
            "619evhn1suw0": "待入庫種類",
            "619evhn1txg0": "待入庫數",
            "619evhn1u580": "暫無數據"
          }
        },
        "hooks": {
          "useReturnGoods": {
            "619eub7jj1s0": "正在入庫中...",
            "61wzjfwnawk0": "入庫數量不能超過{0}個",
            "5uz50t6c8vc0": "退款金額: {0}",
            "5uz50t6c8vc1": "退款金額: {0}（包含打包費）"
          },
          "useScan": {
            "619euwhlq5o0": "加載中",
            "619euwhlqyg0": "暫無數據"
          }
        },
        "returnOrderInfoPage": {
          "index": {
            "619etj4urs80": "退貨入庫",
            "619etj4usrk0": "名稱:",
            "619etj4usxs0": "規格:",
            "619etj4ut1s0": "已經到底啦",
            "619etj4ut540": "直接入庫",
            "619etj4ut980": "掃描商品入庫",
            "619etj4uteg0": "直接入庫後,庫存將增加,確定入庫?",
            "619ekwu8sjn2-0": "退貨數量",
            "619ekwu8sjn2-1": "已入庫數",
            "619ekwu8sjn2-2": "待入庫數",
            "619ekwu8sjn2-3": "無倉位",
            "619ekwu8sjn2-4": "倉位",
            "619ekwu8sjn2-5": "本次入庫",
            "5uz50t6c8vc1": "分銷商退貨單入庫處理後，自動退還:"
          }
        },
        "constant": {
          "619espdpd100": "掃描包裹",
          "619espdpe9k0": "待入庫退貨單"
        },
        "index": {
          "619es2vhols0": "請掃描包裹",
          "619es2vho3o0": "退貨入庫",
          "619es2vhoi80": "請輸入/掃描運單號碼、訂單號碼或包裹號碼",
          "619es2vhooo0": "退貨單入庫成功"
        }
      },
      "scanShipment": {
        "components": {
          "List": {
            "5wsld4f61gw0": "暫無數據"
          },
          "OrderPackageItemMedia": {
            "5wsld4f61gw0": "1、上傳的圖片/視頻可在圖片空間中查看",
            "5wsld4f61gw1": "2、視頻不可超過30M,時長不可超過1分鐘",
            "5wsld4f61gw2": "上傳圖片",
            "5wsld4f61gw3": "上傳視頻",
            "5wsld4f61gw4": "選擇視頻",
            "5wsld4f61gw5": "圖片",
            "5wsld4f61gw6": "視頻",
            "5wsld4f61gw7": "時長不可超過1分鐘"
          },
          "PackageItemGoods": {
            "5wsldq8io7w0": "規格"
          },
          "ShipmentButton": {
            "5wsle2o8bvc0": "發貨"
          }
        },
        "hooks": {
          "useList": {
            "5wslbuh0fts0": "該包裹本次已掃描",
            "5wslbuh0j1c0": "加載中",
            "5wslbuh0j8g0": "暫無數據"
          },
          "useShipmentPackage": {
            "5wslcgxgpio0": "操作中",
            "5wslcgxgu5g0": "發貨失敗",
            "5wslcgxgug00": "發貨成功"
          }
        },
        "index": {
          "5wsl89cm3gw0": "掃描發貨",
          "5wsl89cm7z80": "掃描或輸入包裹號/運單號",
          "5wsl89cm8980": "已掃描",
          "5wsl89cm8ds0": "請掃描包裹信息",
          "5wsl89cm8hc0": "加載中",
          "5wsl89cm8hc1": "掃描後自动发货"
        },
        "scannedListPage": {
          "index": {
            "5wslasiw3rc0": "已掃描",
            "5wslasiw8r40": "確定要移除包裹？",
            "5wslasiw9200": "返回後，已掃描的包裹列表將清空，確定要繼續？",
            "5wslasiw9940": "全部",
            "5wslasiw9f40": "暫無可發貨包裹"
          }
        }
      },
      "singlePick": {
        "baseIndex": {
          "5wesij4whps0": "掃描/輸入波次號",
          "5wesij4whv40": "確定要標記為完成狀態?",
          "5wesij4whyk0": "為了避免重複揀貨,建議和賬號所屬用戶確認或查看操作日誌後,再開始揀貨",
          "5wesij4wi1s0": "標記後,波次{0}將無法揀貨",
          "5wesij4wi5s0": "賬號:{0}於{1}操作揀貨",
          "5wesij4wi0s0": "且波次將進入為待包裝狀態",
          "5wesij4wgig0-1": "波次揀貨"
        },
        "components": {
          "WaveList": {
            "WaveItem": {
              "5wesqu5fcgs0": "已揀/待揀",
              "5wesqu5fi8s0": "商品信息",
              "5wesqu5fihk0": "創建時間",
              "5wesqu5fimg0": "創建人",
              "5wesqu5fizs0": "開始揀貨",
              "5wesqu5fj800": "揀貨日誌",
              "5wesqu5fjck0": "{0}種SKU,共{1}個"
            }
          },
          "InPackingWaveConfirmDialog": {
            "5wesqu5fjck0": "返回",
            "5wesqu5fjck1": "檢測到本賬號已關聯揀貨波次,是否繼續揀貨?"
          },
          "PickingCartBindConfirmPopup": {
            "5wesqu5fjck0": "綁定揀貨車後開始{0}揀貨任務",
            "5wesqu5fjck1": "請輸入/掃描揀貨車編號",
            "5wesqu5fjck2": "關閉",
            "5wesqu5fjck3": "確定",
            "5wesqu5fjck1-1": "請輸入揀貨車編號"
          },
          "FinishWavePickGoodsConfirmDialog": {
            "5wesqu5fjck1": "暫不結束",
            "5wesqu5fjck2": "確定結束",
            "5wesqu5fjck3": "共有{0}包裹缺貨或未完成揀貨,結束揀貨後,對應包裹將標記異常,並移出波次,是否結束?",
            "5wesqu5fjck4": "確定要結束揀貨? 結束後,可前往'掃描包裝'頁面掃描打包",
            "5wesqu5fjck5": "波次中所有包裹缺貨或未完成揀貨,結束揀貨後,對應包裹將標記異常,波次將作廢,是否結束?"
          },
          "common": {
            "tips": "提示"
          }
        },
        "hooks": {
          "useOperate": {
            "5wespf86efs0": "繼續揀貨",
            "5wespf86eys0": "波次狀態已更新,請下拉刷新頁面查看",
            "5wespf86et81": "返回"
          },
          "useSinglePick": {
            "5wespa86efs0": "波次不存在"
          }
        },
        "subPages": {
          "pickLog": {
            "baseIndex": {
              "5weyeh0dlbs0": "揀貨日誌"
            },
            "components": {
              "LogItem": {
                "5weygrs8su40": "商品SKU",
                "5weygrs8xvc0": "揀貨數量"
              }
            }
          },
          "picking": {
            "baseIndex": {
              "5wey0wt55a40": "掃描/輸入SKU、商品代碼",
              "63osfx120mw0": "倉位",
              "63osfx121hs0": "投放框",
              "63osfx121lk0": "應揀/已揀",
              "63osfx121oc0": "清空重置",
              "63osfx121qk0": "標記缺貨",
              "63osfx121t00": "查看揀貨詳情",
              "63osfx121vg0": "關閉揀貨任務",
              "63osfx121xk0": "結束揀貨",
              "5wey1e5fupo2": "揀貨車：{0}",
              "63osfx121xk1": "請輸入"
            },
            "components": {
              "SetPickQuantityDialog": {
                "5wey82q92us0": "填寫已揀數量",
                "5wey82q99rg0": "請輸入",
                "5wey82q9a100": "請輸入已揀數量",
                "5wey82q9a1g0": "已揀數量不能大於待揀數量:{0}"
              },
              "SkuItem": {
                "5wey9z9uook0": "已揀",
                "5wey9z9uoyw0": "待揀"
              },
              "WavePickFinishDialog": {
                "5weycylwol80": "提示",
                "5weycylwsss0": "我已知曉",
                "5weycylwt1c0": "當前波次揀貨已完成！"
              },
              "CloseWavePickGoodsConfirmDialog": {
                "63oskp1zr7w0": "繼續揀貨",
                "63oskp1zryo0": "關閉任務",
                "63oskp1zs300": "關閉任務後，此波次將返回揀貨任務列表，其他賬號可選擇此波次進行揀貨，確定要關閉？"
              }
            },
            "hooks": {
              "usePicking": {
                "5wey5ujb4xs1": "請掃描提示的商品SKU條碼"
              }
            }
          },
          "pickingDetail": {
            "baseIndex": {
              "index": {
                "63osmvhtlfs0": "取消缺貨標識",
                "63osmvhtmgk0": "結束揀貨",
                "63osmvhtmjw0": "確定取消",
                "63osmvhtmmo0": "暫不取消",
                "63osfx121xk3": "請選擇商品"
              },
              "constant": {
                "63ospvovly80": "全部",
                "63ospvovmsw0": "已揀",
                "63ospvovmx40": "未揀",
                "63ospvovmzk0": "缺貨"
              },
              "ListBox": {
                "index": {
                  "63osqzhqna40": "倉位",
                  "63osqzhqnnc0": "應揀/已揀",
                  "63osqzhqnrg0": "缺貨",
                  "63osqzhqntw0": "當前揀貨",
                  "63osqzhqntw1": "列表為空"
                }
              }
            }
          }
        }
      }
    }
  },
  "system": {
    "confirm": "確定",
    "cancel": "取消",
    "pleaseSelect": "請選擇",
    "5rnxe856we80": "提示",
    "5rnxe856wl00": "確認",
    "loading": "正在加載",
    "copySuccess": "複製成功",
    "emptyShelfCell": "無倉位",
    "versionInfo": "版本信息",
    "maintain": "功能維護中，暫時不可用",
    "language": {
      "toggle": "切換語言",
      "selectEmpty": "請選擇語言"
    },
    "tabBar": {
      "stat": "數據",
      "home": "倉庫",
      "my": "我的"
    },
    "update": {
      "title": "更新提示",
      "forceUpdate": "發現新版本,立即重啟",
      "fail": "更新失敗",
      "newVersion": "發現新版本",
      "updateNow": "立即更新",
      "updateLater": "下次更新"
    }
  }
}